import { ROUTE_PATH, regions, genderList, statusList } from "common/constants/sm-constants";
import { FormMetaModel, SmMetaSelectModel } from "common/models/utility-models/meta-model";

export class CreditFilterMetaModel extends FormMetaModel {
    constructor() {
        super('', ROUTE_PATH.reports, ROUTE_PATH.reports, 3);
    }

    override initProperties(): any {
        const formInfo = super.initProperties();
        const selectedBatch = new SmMetaSelectModel(
            'selectedBatch',
            'selectedBatch',
            'select',
            false,
            'col-4',
            1,
            1,
            'Batch',
            'select',
            '',
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            [],
            'batch_number',
            'id',
            false,
            false,
            false,
            false,
            false,
            false,
            { evalKey: '', evalParam: [] },
            null,
            false,
            [],
            true

        );
        const selectedRegion = new SmMetaSelectModel(
            'selectedRegion',
            'selectedRegion',
            'select',
            false,
            'col-4',
            1,
            2,
            'Region',
            'select',
            '',
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            regions,
            'name',
            'value',
            false,
            false,
            false,
            false,
            false,
            false,
            { evalKey: '', evalParam: [] },
            null,
            false,
            [],
            true
        );
        const selectedState = new SmMetaSelectModel(
            'selectedState',
            'selectedState',
            'select',
            false,
            'col-4',
            1,
            3,
            'State',
            'select',
            '',
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            [],
            'stateName',
            'id',
            false,
            false,
            false,
            false,
            false,
            false,
            { evalKey: '', evalParam: [] },
            null,
            false,
            [],
            true
        );
        const selectedBranch = new SmMetaSelectModel(
            'selectedBranch',
            'selectedBranch',
            'select',
            false,
            'col-4 pt-2',
            1,
            4,
            'Branch',
            'select',
            '',
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            [],
            'department_name',
            'id',
            false,
            false,
            false,
            false,
            false,
            false,
            { evalKey: '', evalParam: [] },
            null,
            false,
            [],
            true
        );
        const selectedGender = new SmMetaSelectModel(
            'selectedGender',
            'selectedGender',
            'select',
            false,
            'col-4 pt-2',
            1,
            5,
            'Gender',
            'select',
            '',
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            genderList,
            'name',
            'value',
            false,
            false,
            false,
            false,
            false,
            false,
            { evalKey: '', evalParam: [] },
            null,
            false,
            [],
            true
        );
        const selectedStatus = new SmMetaSelectModel(
            'selectedStatus',
            'selectedStatus',
            'select',
            false,
            'col-4 pt-2',
            1,
            6,
            'Status',
            'select',
            '',
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            statusList,
            'name',
            'value',
            false,
            false,
            false,
            false,
            false,
            false,
            { evalKey: '', evalParam: [] },
            null,
            false,
            [],
            true
        );

        return {
            formInfo,
            selectedBatch,
            selectedBranch,
            selectedGender,
            selectedRegion,
            selectedState,
            selectedStatus,
        }
    }
}